export const loadPopularTlds = (countryCode, locale) => {
  return (dispatch, getState, { api }) => {
    return api.getPopularTlds(countryCode, locale).then(
      (data) => {
        if (data.result) {
          // Only 5 TLDs are shown on the page
          const tlds = data.result.tlds.slice(0, 5);

          return { wasSuccessful: true, tlds };
        } else {
          return { wasSuccessful: false };
        }
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
